export default __webpack_public_path__ + "static/media/boy.c62ce65e.png";